// Hand the approval link to the customer app when the OS did not do it itself.
//
// The path is claimed as a Universal / App Link, so on a phone that honours the
// claim the app opens before this page ever loads. WhatsApp's in-app browsers
// often keep the link instead, which is what this covers.
//
// Nothing here can reach an app store, in any branch. The Android fallback comes
// back to this same page, which is a complete approval screen on its own, and
// the flag it carries is what stops a second attempt looping.

export const ANDROID_PACKAGE = "com.wakilni.customer";
export const APP_SCHEME = "wakilni";

// Set on the fallback URL, and read on the way back in: one attempt per visit.
export const WEB_ONLY_PARAM = "web";

// The same rule for every other way back to this page — the Android fallback
// landing here, and the return trip after a login. One handoff per link, per tab.
const ATTEMPTED_KEY = "cashbox_approval_handoff";

const webOnlyUrl = token =>
  `${window.location.origin}/cashbox-approval/${token}?${WEB_ONLY_PARAM}=1`;

/**
 * Try to open the app on this link. Returns true when an attempt was made — the
 * page still renders underneath either way, since the handoff may silently do
 * nothing.
 */
export function attemptAppHandoff(token) {
  const params = new URLSearchParams(window.location.search);

  // Already came back from an attempt on this link.
  if (
    params.get(WEB_ONLY_PARAM) ||
    sessionStorage.getItem(ATTEMPTED_KEY) === token
  ) {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(userAgent);
  const isIOS = /iphone|ipad|ipod/.test(userAgent);

  if (!isAndroid && !isIOS) {
    return false;
  }

  sessionStorage.setItem(ATTEMPTED_KEY, token);

  if (isAndroid) {
    // browser_fallback_url is this page, never the Play Store: a customer
    // without the app answers here instead of being sent to install it.
    window.location.href =
      `intent://${window.location.host}/cashbox-approval/${token}` +
      `#Intent;scheme=https;package=${ANDROID_PACKAGE};` +
      `S.browser_fallback_url=${encodeURIComponent(webOnlyUrl(token))};end`;

    return true;
  }

  // iOS. No timeout and no second destination: if the app does not take the
  // scheme the customer stays on this page, which is already the answer.
  window.location.assign(`${APP_SCHEME}://cashbox-approval/${token}`);

  return true;
}
